import React from "react";
import { getValue } from "../../utils";
import useUserRoles from "../../hooks/auth/useUserRoles";

const MuscleRow = ({ muscle, handleEdit, handleDelete }) => {
  const { isSuperAdmin } = useUserRoles();

  const renderTag = () => {
    if (muscle.tag && muscle.tag !== null) {
      return muscle.tag.name;
    }
  };

  const renderSuperAdminCols = () => {
    if(isSuperAdmin()) {
      return (
        <div className="col">
          <button
            onClick={() => handleEdit(muscle)}
            className="btn btn-sm btn-outline-primary me-2"
          >
            <i className="fa fa-edit" />
          </button>
          <button
            onClick={() => handleDelete(muscle)}
            className="btn btn-sm btn-outline-danger"
          >
            <i className="fa fa-trash" />
          </button>
        </div>
      )
    }
  }

  return (
    <div className="row px-3 py-2">
      <div className="col">{getValue(muscle, "name")}</div>
      <div className="col">{renderTag()}</div>
      {renderSuperAdminCols()}
    </div>
  );
};

export default MuscleRow;
